// to add expand/collapse in about delivery
        document.addEventListener("DOMContentLoaded", function() {
            if (window.innerWidth <= 768) {
                document.querySelectorAll(".info-box h3").forEach(function(header) {
                    header.addEventListener("click", function() {
                        this.parentElement.classList.toggle("active");
                    });
                });
            }
        });





// --- Early removal of video in mobile and move it to bottom ---
(function() {
  var observer = new MutationObserver(function(mutations, obs) {
    var el = document.querySelector('.videoCol-gallery');
    if (el) {
      el.style.display = 'none'; // hide immediately just in case
      el.remove();               // yank it from the DOM
      window._videoColEl = el;   // store globally to reinsert later
      obs.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// --- Reinsert in correct location ---
document.addEventListener('DOMContentLoaded', function() {
  function placeVideoCol() {
    if (!window._videoColEl) return;

    var safeSticky = document.querySelector('safe-sticky.product-info');
    var productGallery = document.querySelector('product-gallery');

    if (window.innerWidth <= 768 && safeSticky) {
      if (!safeSticky.contains(window._videoColEl)) {
        safeSticky.insertBefore(window._videoColEl, safeSticky.lastChild);
      }
    } else if (productGallery) {
      if (!productGallery.contains(window._videoColEl)) {
        productGallery.appendChild(window._videoColEl);
      }
    }
    window._videoColEl.style.display = ''; // make it visible
  }

  // First placement
  placeVideoCol();

  // Update on resize
  window.addEventListener('resize', placeVideoCol);
});